import { CommonModule, isPlatformServer } from '@angular/common';
import { Component, Input, OnChanges, PLATFORM_ID, inject } from '@angular/core';
import { ISbRichtext } from '@storyblok/js';
import { copy } from 'src/app/lib/copy';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { SvgComponent } from 'src/app/shared/components/svg/svg.component';
import { TooltipDirective } from 'src/app/shared/directives/tooltip.directive';
import { StoryblokRichTextPipe } from '../../storyblok-rich-text.pipe';
import { StoryblokImage } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-comparison',
  standalone: true,
  imports: [
    CommonModule,
    BlockWrapperComponent,
    StoryblokDirective,
    TooltipDirective,
    SvgComponent,
    StoryblokRichTextPipe,
  ],
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.scss'],
})
export class ComparisonComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() groups: {
    _editable: string;
    title: string;
    items: {
      _editable: string;
      feature: {
        image: StoryblokImage;
        title: string;
        text: ISbRichtext;
      };
      competitorValue: boolean;
      competitorCustomValue?: string;
      picflowValue: boolean;
      picflowCustomValue?: string;
    }[];
  }[];
  @Input() title: string;
  @Input() competitorLogo: StoryblokImage;

  private platformId = inject(PLATFORM_ID);

  private storyblokService = inject(StoryblokService);

  ngOnChanges() {
    const relationships = this.storyblokService.getGlobalData('relationships');
    if (isPlatformServer(this.platformId)) this.groups = copy(this.groups);
    this.groups.forEach(group => {
      group.items.forEach(item => {
        item.feature = relationships.find(feature => feature.uuid === item.feature)?.content;
      });
    });
  }
}
